export default "__VITE_ASSET__CvIc7Vrv__"